/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ISystemDocumentScope extends angular.IScope {
        config: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        addNewDocumentType(): void;
        save(): void;
    }

    export class SystemDocumentController implements IController {
        constructor(
            private scope: ISystemDocumentScope,
            private systemLevelService: services.SystemLevelService,
            private manageSystemCodesService: services.ManageSystemCodesService)
        {
            this.systemLevelService.getSystemLevelDocumentConfiguration().then(
                (sysLevel) => {
                    this.scope.config = sysLevel.systemDocumentConfiguration;
                });

            this.scope.save = () => this.save();
            this.scope.addNewDocumentType = () => this.addNewDocumentType();
        }

        private addNewDocumentType(): void {
            const newCode = this.manageSystemCodesService.createNewSystemCode(this.scope.config.documentTypeCodeGroup, true);
            newCode.isActive = true;
            this.scope.config.documentTypeCodeGroup.codes.push(newCode);
            newCode.myParentCodeGroup = this.scope.config.documentTypeCodeGroup;
        }

        private save(): void {
            this.systemLevelService.saveAllChanges();
        }
    }
}

warsApp.registerController('SystemDocumentController', ["$scope", "systemLevelService", "manageSystemCodesService"]);